exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-dropzone[data-v-32291ef6] {\n  background: #eee;\n  border: thin dashed #666;\n}", ""]);

// exports
